import baseComponent from '@/scripts/baseComponent';
import authApi from '@/api/common/auth';
import { API_CALL_STATUS } from "@/constant/config";
import { ROLE_MANAGEMENT_MODIFY_TYPE } from "@/constant/systemManagerStatus";
import { mapState } from "vuex";
import CaretTop from "../../../../views/components/Icon/CaretTop.vue";
import CaretBottom from "../../../../views/components/Icon/CaretBottom.vue";
const queryString = require('query-string');

export default {

    components: {
        CaretTop,
        CaretBottom,
    },

    extends: baseComponent,

    data() {
        return {

            isCheckAll: false,
            listData: [],
            pagination: {
                status: 1,
                querySearch: '',
                orderBy: 'A.FULLNAME',
                directionSort: 'ASC',
                pageIndex: 1,
                pageSize: 500,
                outRowsNumber: 0,
            },

            description: '',
        };
    },

    props: {
        element: {
            type: Object,
            default: {}
        },
    },

    computed: {
        ...mapState({
            user: state => state.auth.user,
            listServicePack: state => state.common.listServicePack,
        }),
    },

    created() {
        this.getData();
    },

    mounted() {
        this.description = this.element.name;
    },

    methods: {

        // Close this pop-up
        closePopup() {
            this.$emit("processingEvent", { event: "closePopup", data: "role-management-staff-manager" });
        },

        // Selected all item
        selectedAll() {
            this.listData.forEach(element => {
                element.isChecked = this.isCheckAll;
            });
        },

        // Selected item
        selectedItem() {
            if (this.listData.filter(x => x.isChecked).length === this.listData.length) {
                this.isCheckAll = true;
            } else {
                this.isCheckAll = false;
            }
        },

        // Action
        performAction(param) {
            switch (param.action) {
                case 'refresh':
                    this.getData(this.pagination);
                    break;
                case 'copyToClipboard':
                    this.copyToClipboard(param.data.inputId, param.data.data);
                    break;
            }
        },

        // Search list
        searchList() {
            this.pagination.status = 0;
            if (this.pagination.querySearch) {
                this.pagination.querySearch = this.pagination.querySearch.substring(this.pagination.querySearch.lastIndexOf("@") + 1);
            }
            this.getData();
        },

        // Sort list
        sortList(element) {
            this.pagination.pageIndex = 1;
            this.pagination.orderBy = element;
            if (this.pagination.directionSort === 'ASC') {
                this.pagination.directionSort = 'DESC'
            } else {
                this.pagination.directionSort = 'ASC'
            }
            this.getData();
        },

        // Pagination size change
        handleSizeChange(pageSize) {
            this.pagination.pageIndex = 1;
            this.pagination.pageSize = pageSize;
            this.getData();
        },

        // Pagination page change
        handleCurrentChange(element) {
            this.pagination.pageIndex = element;
            this.getData();
        },

        //Context menu action
        contextMenuAction(command) {
            switch (command.type) {
                case "modify":
                    this.openPopup({ type: "restricted-email-domain-modify", data: [command.data] });
                    break;
                case "deactivate":
                    // this.modifyDomain(RESTRICTED_EMAIL_DOMAIN_MODIFY_TYPE.DEACTIVATE, [command.data]);
                    break;
                case "activate":
                    // this.modifyDomain(RESTRICTED_EMAIL_DOMAIN_MODIFY_TYPE.ACTIVATE, [command.data]);
                    break;
                case "remove":
                    this.deleteDomain([command.data]);
                    break;
            }
        },

        // Get data
        getData() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            this.isCheckAll = false;
            authApi.staffManagementView(queryString.stringify(this.pagination))
                .then((res) => {
                    try {
                        let responseData = res.data;
                        let pagingItem = res.data.pagingItem;
                        responseData.data.forEach(element => {
                            if (element.decentralized) {
                                let decentralized = element.decentralized.split(', ')
                                if (decentralized.includes(this.element.code)) {
                                    element.isChecked = true;
                                } else {
                                    element.isChecked = false;
                                }
                            } else {
                                element.isChecked = false;
                            }
                        });
                        this.listData = responseData.data;
                        this.pagination.orderBy = pagingItem.orderBy;
                        this.pagination.directionSort = pagingItem.directionSort;
                        this.pagination.pageIndex = pagingItem.pageIndex;
                        this.pagination.pageSize = pagingItem.pageSize;
                        this.pagination.outRowsNumber = pagingItem.outRowsNumber;

                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.listData);
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.feedStatusLoading(API_CALL_STATUS.FAILED);
                    }
                })
                .catch(error => {
                    try {
                        if (error.name === 'Error') {
                            if (this.$route.path !== '/login') {
                                setTimeout(() => {
                                    // location.href = "/login";
                                }, 2000);
                            }
                        } else {
                            switch (error.errorCode) {
                                default:
                                    console.log("getData -> error", error)
                                    // this.$store.dispatch("common/showUnkownError", error, "Error");
                                    break;
                            }
                        }
                    } catch (error) {
                        console.log("getData -> error", error)
                        // this.$store.dispatch("common/showUnkownError", error, "Error");
                    }
                    this.feedStatusLoading(API_CALL_STATUS.FAILED);
                });
        },

        // Modify role
        modifyRole() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            let request = {
                listDataStaff: this.listData.filter(x => x.isChecked),
                roleId: this.element.id,
                type: ROLE_MANAGEMENT_MODIFY_TYPE.STAFF,
                deviceInformation: JSON.stringify(this.getInformationClient()),
            }
            authApi.roleManagementModify(request)
                .then((res) => {
                    try {
                        this.closePopup();
                        this.$emit("processingEvent", { event: "performAction", data: { action: "refresh" } });
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.feedStatusLoading(API_CALL_STATUS.FAILED);
                    }
                })
                .catch(error => {
                    try {
                        if (error.name === 'Error') {
                            if (this.$route.path !== '/login') {
                                setTimeout(() => {
                                    location.href = "/login";
                                }, 2000);
                            }
                        } else {
                            switch (error.errorCode) {
                                default:
                                    console.log("getData -> error", error)
                                    this.$store.dispatch("common/showUnkownError", error, "Error");
                                    break;
                            }
                        }
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.$store.dispatch("common/showUnkownError", error, "Error");
                    }
                    this.feedStatusLoading(API_CALL_STATUS.FAILED);
                });
        },
    },
}